export default __webpack_public_path__ + "static/media/tonivet.05ce6765.svg";